import http from '@/plugins/axios/axios';

export default class MudancaHorarioService {

    salvar(requisicao) {       
        return http.post('/api/mudanca-horario/salvar', requisicao);
    }

    alterar(requisicao) {       
        return http.post('/api/mudanca-horario/alterar', requisicao);
    }

    excluir(requisicao) {       
        return http.post('/api/mudanca-horario/excluir', requisicao);
    }

    buscar(requisicao) {       
        return http.post('/api/mudanca-horario/buscar', requisicao);
    }
    
    listar(requisicao) {       
        return http.post('/api/mudanca-horario/listar', requisicao);
    } 
    
    buscarItemSolicitacao(requisicao) {       
        return http.post('/api/mudanca-horario/buscar-item-solicitacao', requisicao);
    }

    resolverPendenciaNovo(requisicao) {       
        return http.post('/api/mudanca-horario/resolver-pendencia-novo', requisicao);
    }

    resolverPendenciaAlteracao(requisicao) {       
        return http.post('/api/mudanca-horario/resolver-pendencia-alterar', requisicao);
    }

    resolverPendenciaExcluir(requisicao) {       
        return http.post('/api/mudanca-horario/resolver-pendencia-excluir', requisicao);
    }
}